var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"chart-title ts-flex ts-justify-between",class:{ 'text-gray': !_vm.inverseMode }},[_c('strong',[_vm._v(" "+_vm._s(_vm.$t('studentPerformance.pageTitle'))+" ")])]),_c('ts-loading-banner',{attrs:{"loading":_vm.loading}},[_c('div',{staticClass:"widget-chart-full-width ts-px-4",class:{ 'nvd3-inverse-mode': _vm.inverseMode }},[_c('p',[_vm._v("\n        "+_vm._s(_vm.$t(
            'studentPerformance.The_Chart_of_the_Student_Performance_in_all_the_Subjects_and_for_all_Grade_Levels'
          ))+"\n      ")]),_c('bar-chart',{staticStyle:{"min-height":"400px","height":"450px"},attrs:{"data":{
          labels: _vm.labels,
          datasets: _vm.datasets
        },"options":_vm.options}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }